'use client'
import Image from 'next/image'
import Link from 'next/link'
import cl from 'clsx'

import logo from '@/public/images/logo.svg'
import dot from '@/public/icons/dot.svg'
import FooterButton from './footer-button'

import styles from './styles.module.css'

export default function Footer({ dict }) {
    const {
        dataProtection,
        legalNotice,
        copyright
    } = dict.footer

    return (
        <section className={cl(styles.footer, 'footer')}>
            <div className="container">
                <div className={styles.footer__content}>
                    <Image className={styles.footer__logo} src={logo} alt="logo" />
                    <p className={styles.copyright}>
                        {copyright}
                    </p>
                    <div className={styles.footer__link_block}>
                        <Link href="https://ic-ces.at/compliance-policy/" target="_blank">
                            <p className={styles.footer__item}>{dataProtection}</p>
                        </Link>
                        <Image src={dot} alt="dot" />
                        <Link href="https://ic-ces.at/legal-notice/" target="_blank">
                            <p className={styles.footer__item}>{legalNotice}</p>
                        </Link>
                    </div>
                    <FooterButton />
                </div>
                <p className={styles.copyright__mobile}>
                    {copyright}
                </p>
            </div>
        </section>
    )
}
